import React, { useRef, useState } from 'react';

import emailjs from '@emailjs/browser';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import toast, { Toaster } from 'react-hot-toast';

import ChevronIcon from '@/assets/icons/icon-down-arrow.svg';
import { cn } from '@/utils/helper';
import { regexp } from '@/utils/regexp';

import 'rc-dropdown/assets/index.css';
import ThankYouMessage from './ThankYouMessage';

const contactMenu = ['General Inquiry', 'Support', 'Partnership', 'Asset Whitelist'];

const HelpMenuDropdown = ({ categoryHandler }: { categoryHandler: (category: string) => void }) => (
  <Menu className='top-sales-dropdown'>
    {contactMenu.map((item, idx) => {
      return (
        <MenuItem className='text-input bg-white flex items-center text-xs sm:text-sm hover:bg-light-gray' key={idx} onClick={() => categoryHandler(item)}>
          {item}
        </MenuItem>
      );
    })}
  </Menu>
);

const ContactUsForm: React.FC = () => {
  const [values, setValues] = useState({ firstName: '', lastName: '', email: '', text: '', category: '' });
  const [error, setError] = useState({ firstName: '', lastName: '', email: '', text: '' });
  const form = useRef<HTMLFormElement>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [result, setResult] = useState(false);

  const handleDropdownClick = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { value, name } = e.target;
    let obj = { ...error };

    if (value.length > 50 && name === 'firstName') {
      obj = { ...obj, firstName: 'Name should maximum 50 characters' };
    }
    if (value.length > 50 && name === 'lastName') {
      obj = { ...obj, firstName: 'Name should maximum 50 characters' };
    }
    if (!regexp.test(value) && name === 'email') {
      obj = { ...obj, email: 'It should be a valid email adress' };
    } else {
      obj = { ...obj, email: '' };
    }
    setError(obj);
    setValues({ ...values, [name]: value });
  };

  const handleCategory = (category: string) => {
    setValues((prev) => (prev.category === category ? prev : { ...prev, category }));
    setDropdownOpen(false);
  };
  const isAnyFieldEmpty = Object.values(values).some((val) => !val.length);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!isAnyFieldEmpty) {
      const resultData = await toast.promise(emailjs.sendForm('service_py53qtr', 'template_4oang8c', form.current as HTMLFormElement, 'LxIwL9V_bPSMESjBx'), {
        error: 'Oh!Somethibg went wrong!',
        loading: 'Loading...',
        success: 'Your message was successfully sent',
      });
      setValues({ firstName: '', lastName: '', email: '', text: '', category: '' });
      if (resultData) {
        setResult(true);
      }
    }
  };

  return (
    <div className='h-full'>
      <div className={cn('relative overflow-x-hidden pt-9 lg:pt-16 pb-11', !result ? '' : 'h-screen')}>
        <div className='flex flex-col items-center px-5 lg:px-0'>
          <Toaster
            position='top-center'
            containerClassName='m-auto !top-[150px] lg:!top-[85px]'
            toastOptions={{
              className: 'dark:border dark:border-jet-black dark:bg-jet-black',
              loading: {
                className: 'dark:border dark:border-jet-black dark:bg-jet-black',
              },
              error: {
                className: 'dark:border dark:border-jet-black dark:bg-jet-black',
              },
            }}
          />
          {!result ? (
            <div className='flex flex-col items-center w-full relative z-10 max-w-[770px]'>
              <h1 className='text-[52px]/[60px] font-bold text-coal-250 dark:text-white'>Contact Us</h1>
              <p className='text-lg/8 mx-auto max-w-[620px] font-normal text-center dark:text-white text-coal-250 mt-3'>NettyWorth is here to help you. Whether you have questions, need support, or want to discuss partnerships.</p>
              <form onSubmit={handleSubmit} ref={form} className='w-full flex flex-col bg-white dark:bg-grey-coal gap-4 lg:gap-5 border rounded mt-6 lg:mt-12 pt-10 pb-7 px-9 sm:grid sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2'>
                <div className='flex flex-col w-full'>
                  <input onChange={handleChange} value={values.firstName} type='text' placeholder='First Name' name='firstName' className='max-h-[50px] bg-white-100 dark:bg-jet-black focus:border-coal-250 dark:focus:border-white  placeholder:text-sm placeholder:text-coal-250 dark:placeholder:text-white text-sm py-4 px-[14px] w-full border-white-100 dark:border-coal-border rounded border' />
                  {error.firstName && <span className='text-red-400'>{error.firstName}</span>}
                </div>
                <div className='flex flex-col w-full'>
                  <input onChange={handleChange} value={values.lastName} type='text' placeholder='Last Name' name='lastName' className='max-h-[50px] bg-white-100 dark:bg-jet-black focus:border-coal-250 dark:focus:border-white  placeholder:text-sm placeholder:text-coal-250 dark:placeholder:text-white text-sm py-4 px-[14px] w-full border-white-100 dark:border-coal-border rounded border' />
                  {error.lastName && <span className='text-red-400'>{error.lastName}</span>}
                </div>

                <div className='flex flex-col gap-6 w-full lg:flex-row'>
                  <input onChange={handleChange} required value={values.email} type='email' placeholder='Email Address' name='email' className='max-h-[50px] bg-white-100 dark:bg-jet-black focus:border-coal-250 dark:focus:border-white  placeholder:text-sm placeholder:text-coal-250 dark:placeholder:text-white text-sm py-4 px-[14px] w-full border-white-100 dark:border-coal-border rounded border' />
                  {error.email && <span className='text-red-400'>{error.email}</span>}
                </div>

                <Dropdown visible={dropdownOpen} onVisibleChange={handleDropdownClick} animation='slide-up' overlay={<HelpMenuDropdown categoryHandler={handleCategory} />} trigger={['click']}>
                  <div className={cn('max-h-[50px] bg-white-100 dark:bg-jet-black py-4 px-[14px] border flex justify-between rounded items-center', dropdownOpen ? '!border-white' : 'border-white-100 dark:border-coal-border')}>
                    <span className='text-sm placeholder:text-sm placeholder:text-coal-250 dark:placeholder:text-white text-coal-250'>{values.category ? values.category : 'Reason for contact'}</span>
                    <span>
                      <ChevronIcon className='dark:fill-white [&_path]:dark:fill-white' />
                    </span>
                  </div>
                </Dropdown>

                <input type='hidden' value={values.category} name='category' />
                <div className='flex flex-col col-span-2'>
                  <textarea
                    onChange={handleChange}
                    name='text'
                    value={values.text}
                    placeholder='Leave us a message ...'
                    className='bg-white-100 dark:bg-jet-black border-white-100 dark:border-coal-border focus:border-coal-250 dark:focus:border-white  border placeholder:!text-coal-250 dark:placeholder:!text-white placeholder:text-sm text-sm  border-solid rounded px-[14px] py-3 h-[153px] overflow-y-auto resize-none'
                  ></textarea>
                  {error.text && <span className='text-red-400'>{error.text}</span>}
                </div>
                <button type='submit' className='h-[50px] w-[150px] items-center justify-center bg-primary hover:bg-coal-250 rounded focus:border-primary text-white text-base font-bold dark:!bg-primary' disabled={isAnyFieldEmpty}>
                  Send
                </button>
              </form>
            </div>
          ) : (
            <ThankYouMessage />
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactUsForm;
